// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import moment from 'moment'; // 日期组件
import { tableFormat } from "@/utils/tools"; //金额格式化
//vant
import {
  Button, Form, Field, Cell, CellGroup, Toast, Tabbar, TabbarItem, NavBar, Icon, ActionSheet,
  Grid, GridItem, Sticky, Tab, Tabs, Col, Row, Popup, Sidebar, SidebarItem, DatetimePicker,
  Checkbox, CheckboxGroup, Search, Progress, Calendar, Tag, Badge, DropdownMenu, DropdownItem,
  List, Image as VanImage, Dialog, RadioGroup, Radio, Switch, Circle, PullRefresh, Collapse, CollapseItem
} from 'vant';
//图表v-charts
import VeLine from 'v-charts/lib/line.common';
import VeBar from 'v-charts/lib/bar.common';
import VeHistogram from 'v-charts/lib/histogram.common';
import pie from 'v-charts/lib/pie.common';
import ring from 'v-charts/lib/ring.common';
import 'echarts/lib/component/dataZoom';
// 引入自定义图标
import '@/assets/icon_font/iconfont.css';

Vue.config.productionTip = false;

//饿了么element
Vue.use(ElementUI);
//有赞vant2
Vue.use(Button);
Vue.use(Form);
Vue.use(Field);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Toast);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(NavBar);
Vue.use(Icon);
Vue.use(ActionSheet);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Sticky);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Col);
Vue.use(Row);
Vue.use(Popup);
Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(DatetimePicker);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Search);
Vue.use(Progress);
Vue.use(Calendar);
Vue.use(Tag);
Vue.use(Badge);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(List);
Vue.use(VanImage);
Vue.use(Dialog);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Switch);
Vue.use(Circle);
Vue.use(PullRefresh);
Vue.use(Collapse);
Vue.use(CollapseItem);
//图表v-charts
Vue.component(VeLine.name, VeLine);
Vue.component(VeBar.name, VeBar);
Vue.component(VeHistogram.name, VeHistogram);
Vue.component(pie.name, pie);
Vue.component(ring.name, ring);

Vue.prototype.$moment = moment;
Vue.prototype.tableFormat = tableFormat;

//自定义过滤器
// 金额千分位和两位小数格式化过滤
Vue.filter("AmtDecimalFormat", (value) => {
  if (!value) return "0.00";
  value = value.toFixed(2);
  // 获取整数部分
  const intPart = Math.trunc(value);
  // 整数部分处理，增加,
  const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  // 预定义小数部分
  let floatPart = '';
  // 将数值截取为小数部分和整数部分
  const valueArray = value.toString().split('.');
  floatPart = valueArray[1].toString(); // 取得小数部分
  if (Math.abs(value) < 1 && value < 0)
    return '-0.' + floatPart.slice(0, 2);
  else
    return intPartFormat + '.' + floatPart.slice(0, 2);
});
// 金额千分位格式化过滤
Vue.filter("AmtFormat", (value) => {
  if (!value) return 0;
  // 获取整数部分
  const intPart = Math.trunc(value);
  // 整数部分处理，增加,
  const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');

  return intPartFormat;
  /* 去掉小数
  // 预定义小数部分
  let floatPart = '';
  // 将数值截取为小数部分和整数部分
  const valueArray = value.toString().split('.');

  if (valueArray.length === 2) {
    floatPart = valueArray[1].toString(); // 取得小数部分
    return intPartFormat + '.' + floatPart.slice(0, 2);
  } else {
    return intPartFormat;
  }*/
});
//周几过滤器
Vue.filter("WeekFormat", (value) => {
  if (value == '今日') return value;
  let WeekDays = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
  return WeekDays[value];
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js